.truncated_text_box {
    position: relative;

    &[data-collapsed="false"] {
        .truncated__text {
            -webkit-box-orient: unset;
        }
    }
}

.truncated_text__shadow {
    // fades into the card the text sits on (override with --truncate-fade where that is not the surface)
    background: linear-gradient(transparent, var(--truncate-fade, var(--axl-surface)));
    height: 60px;
    width: 100%;
    position: absolute;
}